import React from "react";
import { InputJson, Progress } from "../../nq-component";
import ExitFormPagePresenter from "./ExitFormPagePresenter";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import withRouter from "../../withRouter";
import BaseFormPage from "../../base/BaseFormPage";
import NavBar from "../../components/navbar";
import FormFactory from "../../components/FormFactory";
import ExitForm from "./components/ExitForm";

class ExitFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false, employeeDetails: {} };
    this.presenter = new ExitFormPagePresenter(
      this,
      upsertUseCase(),
      getObjectUseCase(),
      findObjectUseCase(),
      deleteObjectUseCase()
    );
  }

  getCollectionName() {
    return "exit_interview";
  }

  getObjectId() {
    return this.props.params.id;
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  onSubmitForm(object) {
    this.presenter.onSubmitForm(object);
  }

  goBack() {
    window.history.back();
  }

  render() {
    const { object, advanced, employeeDetails, progress } = this.state;
    const user = this.getCurrentUser();
    const schema = this.getSchema(this.getCollectionName());
    console.log("schema", schema, "object", object);
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add New " : "Edit ";

    delete schema.fields.id;
    delete schema.fields.created;
    delete schema.fields.updated;
    delete schema.fields.acl;

    const disabled =
      employeeDetails?.exit_interview?.id !== object?.id ? true : false;

    console.warn(employeeDetails, object);
    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="d-flex">
                <h1 className="fw-bold fs-4">
                  <div className="d-flex gap-3 mb-3 align-items-center">
                    <div
                      className="rounded-5 p-1 cursor-pointer"
                      style={{ backgroundColor: `#E6E6E6` }}
                      onClick={this.goBack.bind(this)}
                    >
                      <i
                        class="bi bi-arrow-left-short"
                        style={{ width: `1rem`, height: `1rem` }}
                      ></i>
                    </div>
                    <span style={{ color: `#D18237` }}>
                      Exit Interview Form
                    </span>
                  </div>
                </h1>
              </div>

              {progress ? (
                <Progress />
              ) : (
                <div className="mt-1 bg-white rounded p-3 px-lg-5 py-lg-4">
                  <ExitForm
                    onSubmitForm={this.onSubmitForm.bind(this)}
                    goBack={this.goBack.bind(this)}
                    schema={schema}
                    object={object}
                    isDisabled={disabled}
                  />{" "}
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ExitFormPage);
